import Image from 'next/legacy/image'

export const PlainPatternImage = ({ angled = false }: { angled?: boolean }) => (
  <Image
    src={
      angled
        ? '/design/onlineEditor/pattern-plain-angled.svg'
        : '/design/onlineEditor/pattern-plain.svg'
    }
    height={110}
    width={160}
  />
)

export const OffsetPatternImage = ({
  angled = false,
}: {
  angled?: boolean
}) => (
  <Image
    src={
      angled
        ? '/design/onlineEditor/pattern-offset-angled.svg'
        : '/design/onlineEditor/pattern-offset.svg'
    }
    height={110}
    width={160}
  />
)

export const angleMapper = (angled: boolean) =>
  angled
    ? { displayLabel: 'Angled', key: 'angled' }
    : {
        displayLabel: 'Straight',
        key: 'straight',
      }

export const offsetMapper = (offset: boolean) =>
  offset
    ? {
        displayLabel: <OffsetPatternImage />,
        key: 'offset',
      }
    : {
        displayLabel: <PlainPatternImage />,
        key: 'plain',
      }
